module.exports = __webpack_public_path__ + "img/1531601098.018668b1.jpg";